export const MY_PAY_SLIP_EMPLOYEE_ID = 'emp-s01';
export const MY_CLOCKING_EMPLOYEE_ID = 'emp-001';
/** 勤務スケジュール閲覧で「自分」とみなす薬局シフトスタッフ（渋谷店の薬剤師 田中 美咲）。 */
const MY_WORK_SCHEDULE_STAFF_ID = 'staff-sby-ph1';
export function useMyPaySlipEmployeeId(): string {
  return MY_PAY_SLIP_EMPLOYEE_ID;
}
export function useMyClockingEmployeeId(): string {
  return MY_CLOCKING_EMPLOYEE_ID;
}
export function useMyWorkScheduleStaffId(): string {
  return MY_WORK_SCHEDULE_STAFF_ID;
}